var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-details"},[_c('span',[_vm._v(_vm._s(_vm.details.nights))]),_c('span',[_vm._v(_vm._s(_vm.details.occupancy))]),(!_vm.points_available)?_c('span',{staticClass:"semibold"},[_vm._v("€ "+_vm._s(_vm.details.price_nightly)+" per notte")]):_vm._e(),_c('sale-scenario',{attrs:{"sale":_vm.details.sale_scenario}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }